module.exports = __webpack_public_path__ + "img/rico-ua.eac63210.png";